import React, { Component, Fragment } from 'react';
import i18n from "../../i18next";
import { connect } from "react-redux";
import { loadRestrictions, updateRestriction, getCronJobByTime, canUserAccessPauseAllRestaurants, triggeringCronJobAction, resetUserAccessPauseAllRestaurants } from '../../actions/index';
import { Col, Container, Input, Row, Button } from 'reactstrap';
import { AvForm, AvGroup, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from "material-icons-react";
import ConfirmationModal from '../common/ConfirmationModal';
import ModalContent from './database/common/ModalContent';

class RestrictionsScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            restrictions: [],
            stateAlreadyCopiedFromProps: false,
            isConfirmationOpen: false,
            password: '',
        };

        this.changeState = this.changeState.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {
        this.props.loadRestrictions();
        this.props.getCronJobByTime();
    }

    changeState({ target }) {
        if (!target.value === 'password') {
            const restriction = {
                actionType: target.name,
                restrict: target.value
            }

            this.props.updateRestriction(restriction);
        } else {
            this.setState({
                ...this.state,
                [target.name]: target.value
            });
        }
    }

    toggleModal() {

        this.setState({
            ...this.state,
            isConfirmationOpen: !this.state.isConfirmationOpen,
            password: ''
        });
    }

    renderModalContent(cronJobId) {
        const { canAccessPauseAllRestaurants } = this.props.user;


        return <ModalContent
            onToggle={() => this.toggleModal()}
            headerText={i18n.t('screens:restrictionsScreen.triggerCronJob')}
            bodyContent={!canAccessPauseAllRestaurants ? this.renderSecurityCodeField() : null}
            onConfirm={() => this.requireSecurityCode(cronJobId)}
            onCancel={() => this.toggleModal()} />;
    }

    renderSecurityCodeField = () => {

        return (
            <AvForm onValidSubmit={() => this.props.canUserAccessPauseAllRestaurants(this.state.password)}>
                <AvGroup>
                    <span style={{ position: 'absolute', left: 25, top: 25 }}><MaterialIcon icon="lock" size={20} color="#a9a9a9" />
                    </span>
                    <AvField
                        style={{ paddingLeft: 36 }}
                        placeholder={i18n.t('common:form.password')}
                        type="password" name="password" id="password"
                        value={this.state.password}
                        onChange={this.changeState}
                        required
                        errorMessage={i18n.t('common:validations.errorMsg')}
                    />
                </AvGroup>
            </AvForm>
        );
    }

    requireSecurityCode(cronJobId) {

        this.props.canUserAccessPauseAllRestaurants(this.state.password,
            () => {
                this.props.triggeringCronJobAction(cronJobId, () => {
                    this.setState({
                        ...this.state,
                        isConfirmationOpen: false,
                        password: ''
                    });
                    this.props.resetUserAccessPauseAllRestaurants();
                })
            });
        return;
    }

    renderTriggerCronJobButton() {

        return (
            <Button onClick={() => this.toggleModal()} color='link' style={{ paddingLeft: '0px' }}>Trigger a cron job</Button>
        )
    }

    renderHeading() {
        const { screenHeading } = styles;

        return (
            <Row>
                <div style={screenHeading}>
                    <MaterialIcon icon="pan_tool" color="#0288d1" size={22} />&nbsp;
                     {i18n.t('screens:restrictionsScreen.restrictions')}
                </div>
            </Row>
        );
    }

    renderManualActionsHeading() {
        const { screenHeading } = styles;

        return (
            <Row>
                <div style={{ ...screenHeading, marginTop: '40px', paddingLeft: '15px' }}>
                    {i18n.t('screens:restrictionsScreen.manualActions')}
                </div>
            </Row>
        );
    }

    renderBody() {
        const { restrictionsHeader, restrictionsDetailsCol } = styles;

        return <div>
            <Row style={restrictionsHeader}>
                <Col md={2} style={restrictionsDetailsCol}>{i18n.t('screens:restrictionsScreen.actionType')}</Col>
                <Col md={2} style={restrictionsDetailsCol}>{i18n.t('screens:restrictionsScreen.systemType')}</Col>
                <Col md={7} style={restrictionsDetailsCol}>{i18n.t('screens:restrictionsScreen.description')}</Col>
                <Col md={1} style={restrictionsDetailsCol}>{i18n.t('screens:restrictionsScreen.disabled')}</Col>
            </Row>
            {this.renderRestrictionsDetails()}
            {this.renderManualActionsHeading()}
            <Row style={restrictionsHeader}>
                <Col md={4} style={restrictionsDetailsCol}>{i18n.t('screens:restrictionsScreen.actionType')}</Col>
                <Col md={4} style={restrictionsDetailsCol}>{i18n.t('screens:restrictionsScreen.executionTime')}</Col>
                <Col md={4} style={restrictionsDetailsCol}>{i18n.t('screens:restrictionsScreen.triggerCronJob')}</Col>
            </Row>
            {this.renderManualActionsBody()}
        </div>
    }

    renderRestrictionsDetails() {
        const { restrictionsDetailsRow, restrictionsDetailsCol, disabledCol, inputStyle } = styles;

        return this.props.restrictions.length > 0 ? this.props.restrictions.map((restriction, i) => {
            return <Row key={i} style={restrictionsDetailsRow}>
                <Col md={2} style={restrictionsDetailsCol}>{i18n.t(`screens:restrictionsScreen.${restriction.actionType}`)}</Col>
                <Col md={2} style={restrictionsDetailsCol}>{restriction.systemType}</Col>
                <Col md={7} style={restrictionsDetailsCol}>{restriction.description}</Col>
                <Col md={1} style={disabledCol}>
                    <Input
                        style={inputStyle}
                        type="checkbox"
                        id={restriction.id}
                        name={restriction.actionType}
                        checked={restriction.restrict}
                        onChange={(e) => {
                            this.changeState({
                                target: {
                                    name: e.target.name,
                                    value: e.target.checked,
                                },
                            });
                        }}
                    />
                </Col>
            </Row>
        }) : null
    }

    renderManualActionsBody() {
        const { restrictionsDetailsRow, restrictionsDetailsCol } = styles;

        return this.props.cronJobByTime.length > 0 ? this.props.cronJobByTime.map((cronJob, i) => {
            return <Row key={i} style={restrictionsDetailsRow}>
                <Col md={4} style={restrictionsDetailsCol}>{cronJob.action.replace("_", " ")}</Col>
                <Col md={4} style={restrictionsDetailsCol}>{cronJob.executionTime}</Col>
                <Col md={4} style={restrictionsDetailsCol}>{this.renderTriggerCronJobButton()}</Col>
                {
                    this.state.isConfirmationOpen &&
                    <ConfirmationModal
                        isOpen={this.state.isConfirmationOpen}
                        onToggle={() => this.toggleModal()}>
                        {this.renderModalContent(cronJob.id)}
                    </ConfirmationModal>
                }
            </Row>
        }) : null
    }

    render() {
        const { containerStyle } = styles;

        return <Container fluid style={containerStyle}>
            {this.renderHeading()}
            {this.renderBody()}
        </Container>
    }
}

const mapStateToProps = state => {
    return {
        restrictions: state.restrictions,
        cronJobByTime: state.cronJobByTime,
        user: state.user
    }
}

export default connect(mapStateToProps, { loadRestrictions, updateRestriction, getCronJobByTime, canUserAccessPauseAllRestaurants, triggeringCronJobAction, resetUserAccessPauseAllRestaurants })(RestrictionsScreen);

let styles = {
    containerStyle: {
        marginLeft: 0,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        padding: 10
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    restrictionsHeader: {
        margin: 0,
        backgroundColor: "rgba(204, 204, 204, 0.24)"
    },
    restrictionsDetailsRow: {
        padding: "5px 15px"
    },
    restrictionsDetailsCol: {
        display: "flex",
        alignItems: "center",
        padding: "8px 16px",
        borderBottom: "1px solid rgb(222, 226, 230)"
    },
    disabledCol: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderBottom: "1px solid rgb(222, 226, 230)"
    },
    inputStyle: {
        margin: 0,
        padding: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/systemControl/RestrictionsScreen.js